<template>
    <div class="course-ware-content" :native="false">
        <wareDetailModule
            :typeId="typeId"
            :zhangIndex="zhangIndex"
            :jieIndex="jieIndex"
            :file_path="file_path"
        />
    </div>
</template>

<script>
import wareDetailModule from '@/components/schoolAdministrator/course/FeaturedDetail'

export default {
    name: 'CourseWareDetail',
    props: ['courseInfos', 'nodeIndex', 'chapterIndex'],
    components: {
        wareDetailModule
    },
    data() {
        return {
            typeId: '',
            zhangIndex: '',
            jieIndex: '',
            file_path: ''
        }
    },
    created() {
        // this.getCourseInfo();
        this.typeId = Number(this.$route.query.typeId)
        this.zhangIndex = this.$route.query.zhangIndex
        this.jieIndex = this.$route.query.jieIndex
        this.file_path = this.$route.query.file_path
    },
    methods: {
        handleClick(val) {
            this.$emit('handleSave', true)
        },
        handleList(val) {
            this.$emit('handleList', val)
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .el-breadcrumb {
    padding-bottom: 20px;
}

.course-ware-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
</style>
